import { useState, useEffect, useCallback } from 'react'

type Theme = 'dark' | 'light'

const THEME_KEY = 'cparser-theme'

function getStoredTheme(): Theme {
    try {
        const stored = localStorage.getItem(THEME_KEY)
        if (stored === 'light' || stored === 'dark') return stored
    } catch { /* ignore */ }
    return 'dark'
}

export function useTheme() {
    const [theme, setThemeState] = useState<Theme>(getStoredTheme)

    useEffect(() => {
        const root = document.documentElement
        if (theme === 'dark') {
            root.classList.add('dark')
        } else {
            root.classList.remove('dark')
        }
        localStorage.setItem(THEME_KEY, theme)
    }, [theme])

    const toggleTheme = useCallback(() => {
        setThemeState(prev => (prev === 'dark' ? 'light' : 'dark'))
    }, [])

    const setTheme = useCallback((t: Theme) => {
        setThemeState(t)
    }, [])

    return { theme, toggleTheme, setTheme }
}
